import GROUP, { Hide, Hideable, Show } from '../../../DOM/GROUP/GROUP.js';
import DIV from '../../../DOM/div/DIV.js';
import { HTMLELEMENT } from '../../../../enums/HTMLELEMENT.js';
import BUTTON from '../../../DOM/button/BUTTON.js';
import EL from '../../../EL/EL.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import SWITCHBUTTON from '../../../DOM/button/switchbutton/SWITCHBUTTON.js';
// Model Structure
export const buttongroupAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const buttongroupData = makeDataStruct([
    ['children', []]
]);
export const buttongroupModel = makeStruct([
    ['attributes', buttongroupAttr],
    ['data', buttongroupData]
]);
// Simplified Model
export function buttongroup(name, className) {
    return {
        attributes: buttongroupAttr(name, className),
        data: buttongroupData()
    };
}
/** A container for Buttons */
export default class BUTTONGROUP extends GROUP {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('btn-group').addClass('horizontal', !this.hasClass('vertical'));
    }
    /** Creates a button and adds it to this button group, then adds it to the buttons array */
    addButtonGroup(model) {
        return this.addChild(new BUTTONGROUP(this, model));
    }
    /** Creates a button and adds it to this button group, then adds it to the buttons array */
    addButton(model) {
        return this.addChild(new BUTTON(this, model).on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
        }));
    }
    /** Createa a switch button */
    addSwitch(model) {
        return this.addChild(new SWITCHBUTTON(this, model))
            .on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
        });
    }
}
export { BUTTON, DIV, EL, Hide, Hideable, Show, SWITCHBUTTON };
